<script lang="ts">
  import { fly } from "svelte/transition";
  import { selected_game } from "./stores";

  window.history.replaceState({}, document.title, window.location.pathname);

  import MediaQuery from "./Reusables/MediaQuery.svelte";

  const games = [
    {
      name: "Connect4",
      image:
        "https://cdn.discordapp.com/attachments/829072008733261834/918290891154800680/unknown.png",
    },
    {
      name: "Filler",
      image:
        "https://cdn.discordapp.com/attachments/732309032240545883/782327997096263700/unknown.png",
    },
    {
      name: "Wordle",
      image:
        "https://cdn.discordapp.com/attachments/829072008733261834/946893839107497995/unknown.png",
    },
    {
      name: "Coming Soon",
      image:
        "https://cdn.discordapp.com/attachments/869367514008793128/919673410336985149/Grey_thumb.png",
    },
    {
      name: "Coming Soon",
      image:
        "https://cdn.discordapp.com/attachments/869367514008793128/919673410336985149/Grey_thumb.png",
    },
    {
      name: "Coming Soon",
      image:
        "https://cdn.discordapp.com/attachments/869367514008793128/919673410336985149/Grey_thumb.png",
    },
    {
      name: "Coming Soon",
      image:
        "https://cdn.discordapp.com/attachments/869367514008793128/919673410336985149/Grey_thumb.png",
    },
    {
      name: "Coming Soon",
      image:
        "https://cdn.discordapp.com/attachments/869367514008793128/919673410336985149/Grey_thumb.png",
    },
    {
      name: "Coming Soon",
      image:
        "https://cdn.discordapp.com/attachments/869367514008793128/919673410336985149/Grey_thumb.png",
    },
  ];
</script>

<div class="outter">
  <div class="inner">
    <div class="everything">
      <h1>Games</h1>

      <MediaQuery query="(min-width: 785px)" let:matches>
        {#if matches}
          <div in:fly={{ y: 300, duration: 800 }} class="games-big">
            {#each games as { name, image }}
              <div class="card-big" on:click={() => selected_game.set(name)}>
                <img
                  class="image"
                  src={image}
                  alt={name}
                  draggable="false"
                  on:click={() => selected_game.set(name)}
                />
                <div class="container" on:click={() => selected_game.set(name)}>
                  <h4 on:click={() => selected_game.set(name)}>{name}</h4>
                </div>
              </div>
            {/each}
          </div>
        {:else}
          <div in:fly={{ y: 300, duration: 800 }} class="games-small">
            {#each games as { name, image }}
              <div class="card-small" on:click={() => selected_game.set(name)}>
                <div class="container" on:click={() => selected_game.set(name)}>
                  <h4 on:click={() => selected_game.set(name)}>{name}</h4>
                </div>
                <img
                  class="image"
                  src={image}
                  alt={name}
                  draggable="false"
                  on:click={() => selected_game.set(name)}
                />
              </div>
            {/each}
          </div>
        {/if}
      </MediaQuery>
    </div>
  </div>
</div>

<style>
  .outter {
    height: 100vh;
    display: flex;
    align-content: center;
    overflow: hidden;
  }

  .inner {
    text-align: center;
    margin: auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .games-big {
    display: grid;
    grid-template-columns: repeat(3, 13rem);
    grid-template-rows: repeat(3, 14rem);
  }

  .card-big {
    background-color: var(--accent-color);
    padding: 1rem;
    border-radius: 10px;
    margin: 0.5rem;
    width: 10rem;
    height: 11rem;
    justify-content: center;
    align-items: center;
    transform: translateY(-8px);
    box-shadow: var(--accent-color-shadow) 0px 8px 0px;
    transition: all 100ms;
    user-select: none;
    cursor: pointer;
  }

  .card-big:hover {
    transform: translateY(-8px) translateY(-4px);
    box-shadow: var(--accent-color-shadow) 0px 12px 0px;
  }

  .card-big:not(:disabled):active {
    /* color: var(--text-color-active); */
    transform: translateY(-8px) translateY(4px);
    box-shadow: var(--accent-color-shadow) 0px 4px 0px;
    /* background-color: var(--special-color-active); */
  }

  .card-big .image {
    height: 10rem;
    width: 10rem;
    border-radius: 5px;
    user-select: none;
    box-shadow: var(--accent-color-shadow) 0px 0px 0px 2px;
  }

  .card-small {
    background-color: var(--accent-color);
    display: flex;
    padding: 0.5rem;
    border-radius: 5px;
    margin: 0.5rem;
    width: 20rem;
    height: 3rem;
    justify-content: space-between;
    align-items: center;
    transform: translateY(-2px);
    box-shadow: var(--accent-color-shadow) 0px 4px 0px;
    user-select: none;
    cursor: pointer;
    transition: all 100ms;
  }

  .card-small:hover {
    transform: translateY(-2px) translateY(-2px);
    box-shadow: var(--accent-color-shadow) 0px 6px 0px;
  }

  .card-small:not(:disabled):active {
    /* color: var(--text-color-active); */
    transform: translateY(-2px) translateY(2px);
    box-shadow: var(--accent-color-shadow) 0px 2px 0px;
    /* background-color: var(--special-color-active); */
  }

  .card-small .image {
    height: 3rem;
    width: 3rem;
    border-radius: 3px;
    margin: 0.5rem 0;
  }

  .container h4 {
    user-select: none;

    margin: 0;
  }
</style>
